<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-md btn-link"
                :to="{ name: 'inventario-recepcion_devolucion' }"
              >
                <i class="fas fa-chevron-left"></i>
                Regresar
              </router-link>
              <h6 class="form-header">
                Recepción Devoluciones
                <span class="text-success"> #{{ current.numero }}</span>
                <br />
                <span></span>
                <div
                  class="badge"
                  :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'C',
                    'badge-danger': current.estado == '9',
                  }"
                >
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{ current.estado_str }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
              </h6>
              <div class="st-meta float-right">
                <div class="element-actions">
                  &nbsp;
                  <div class="btn-group">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                    >
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <!-- <button
                        class="dropdown-item"
                        :class="{ disabled: !(current.estado == 'B') }"
                        @click="abrir"
                        :disabled="!(current.estado == 'B')"
                        href="#"
                      >
                        <i class="fa fa-unlock"></i>
                        Abrir Operación
                      </button> -->
                      <button
                        class="dropdown-item"
                        @click="cerrar"
                        :disabled="!(current.estado == 'A')"
                        href="#"
                      >
                        <i class="fa fa-lock"></i>
                        Finalizar Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="anular"
                        :disabled="!(current.estado != '9')"
                        href="#"
                      >
                        <i class="fa fa-archive"></i>
                        Anular Operación
                      </button>
                      <button
                        :disabled="current.estado == 'A'"
                        class="dropdown-item"
                        @click="imprimir"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                      <div class="dropdown-divider"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="font-weight-bold">
                <br />
                <span v-if="current.proveedor_obj"
                  >Proveedor:
                  <span class="text-success"
                    >{{ current.proveedor_obj.codigo }} -
                    {{ current.proveedor_obj.nombre }}</span
                  >
                </span>
                <br />
                <span v-if="current.tienda_obj"
                  >Tienda:
                  <span class="text-success">{{ current.tienda_obj.nombre }}</span></span
                >
                <br />
                <span
                  >Usuario:
                  <span class="text-success">{{ current.usuario_obj.username }}</span>
                </span>
                <br />
                <span
                  >Fecha creación:
                  <span class="text-success">{{ current.fecha_creacion }}</span>
                </span>
                <br />
                <span
                  >Fecha finalización:
                  <span class="text-success">{{ current.fecha_finalizacion }}</span>
                </span>
              </div>
              <small
                v-if="current.errors && current.errors.detail"
                class="form-text text-danger"
                >{{ current.errors.detail }}</small
              >
              <div class="row"></div>
              <div>
                <br />
                <button
                  type="button"
                  class="btn btn-md btn-block btn-dark"
                  @click="showModalAddDetail"
                  v-if="current.estado == 'A' && current.id"
                >
                  <i class="fa fa-plus"></i>
                  Agregar Detalle
                </button>
              </div>
              <br />
              <div class="table-responsive">
                <!-------------------- Tabla de REsultados -------------------->

                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="det in current.recepciondevprod_set"
                      v-bind:key="det.id"
                      @click="abrirModalEliminar(det)"
                    >
                      <td>
                        <div class="value">
                          <small class="font-weight-bold">{{
                            det.producto.nombre
                          }}</small>
                        </div>
                        <small>
                          <div class="value">
                            {{ det.producto.sku }}
                          </div>
                        </small>
                        <span class="sub-value font-weight-bold">
                          Abonado:
                          <span class="text-success">Q{{ det.total }}</span>
                        </span>
                      </td>
                      <td>
                        <span class="sub-value">
                          <span class="sub-value font-weight-bold">
                            Costo /U:
                            <span class="text-success">Q{{ det.precio_lc }}</span>
                          </span>
                        </span>
                        <br />
                        <span class="sub-value font-weight-bold">
                          Cantidad:
                          <span class="text-success">{{ det.cantidad }}</span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="deteleDetalle"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button @click="eliminarDetalle()" class="btn btn-danger btn-block">
              Eliminar Detalle
            </button>
          </div>
        </div>
      </div>
    </div>
    <DevolucionRecepcionModalComponent
      @refreshDevspendientes="refreshAll()"
      :devs="devs"
      :current="current"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DevolucionRecepcionModalComponent from "@/components/wms/devolucion_recepcion/DevolucionRecepcionModalComponent";

export default {
  components: { ProveedoresSelectComponent, DevolucionRecepcionModalComponent },
  data() {
    return {
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "",
        estado: "A",
        errors: [],
        errors: [],
        proveedor: "",
        usuario_obj: "",
      },
      devs: "",
      productos: [],
      posiciones: [],
      options: [],
      producto_lote: [],

      bodegas: [],
      secciones: [],
      racks: [],
      niveles: [],
      det: {
        descripcion: "",
        codigo: "",
      },
      linea_eliminar: "",
      busqueda_posicion: {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      },
      currentDetalle: {
        cantidad: 0,
        posicion: "",
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    let self = this;
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    abrirModalEliminar(det) {
      let self = this;
      if (self.current.estado != "A") {
        return;
      }
      self.linea_eliminar = det;
      $("#deteleDetalle").modal("show");
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("wms", "recepcion_dev_prov_e", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          self.current.proveedor = self.current.proveedor_obj;
          self.current.usuario = self.current.usuario_obj.username;
          self.current.fecha_creacion = moment(self.current.fecha_creacion).format(
            "YYYY/MM/DD"
          );
        }
      );
    },
    showModalAddDetail() {
      let self = this;
      self.refreshDevspendientes();
      $("#modalAddDetailDevs").modal();
    },
    refreshAll() {
      let self = this;
      self.refreshDevspendientes();
      self.refreshCurrent();
    },
    refreshDevspendientes() {
      let self = this;
      DynamicService.getActionList(
        "wms",
        "recepcion_dev_prov_e",
        "obtener_devs_pendientes",
        { proveedor: self.current.proveedor.codigo }
      ).then((response) => {
        self.devs = response.data;
      });
    },
    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Linea de recepcion devolución",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion_dev_prov_e",
            self.current.id,
            "eliminar_detalle",
            {
              id: self.linea_eliminar.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Linea de recepcion devolución",
                "Se ha eliminado la Información."
              );
              $("#deteleDetalle").modal("hide");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Eliminar linea", error.response.data.detail);
              $("#deteleDetalle").modal("hide");
              self.current.errors = error.response.data;
            });
        }
      );
    },
    ModificarDetalle(detalle) {
      let self = this;
      AjusteInventarioService.editarDetalle(self.current.id, detalle)
        .then((response) => {
          Notifications.alert.success("Información", "Guardado Correctamente");
          self.refreshCurrent();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Ajuste de Inventario",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          AjusteInventarioService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Ajuste de Inventario",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Recepción Devolución",
        "Desea cerrar la transacción?",
        "Si cerrar",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion_dev_prov_e",
            self.current.id,
            "cerrar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Recepción Devolución",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Recepción Devolución",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion_dev_prov_e",
            self.current.id,
            "anular"
          )
            .then((response) => {
              Notifications.alert.success(
                "Recepción Devolución",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    imprimir() {
      let op;
      op = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let us = localStorage.getItem("id_usuario");
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/recepecion_devolucion_proveedor/devolucion_proveedor.jrxml&id=${op}&usuario=${us}`
      );
    },
  },
};
</script>
